import CategoryDashboard from "./CategoryDashboard.vue";

export default CategoryDashboard;
